export const CONSTANTS = {
  LOADING: $localize`Loading...`,
};
